// import firebase from "firebase";
import db from "./db.js";
import { OlabGene } from "./olabgene.js";
import { OlabItem } from "./olabitem.js";
import { OlabUtils } from "./olabutils.js";

class OlabComp {
  static availBoxType = {
    gene: false,
    promoter: false,
    rbs: false,
    pgst: false,
    terminator: false,
    us_ds: false
  };

  constructor(cItem) {
    if (cItem == null) {
      this.initComp();
    } else {
      this.comp = cItem;
      this.display_name = this.getDisplayName();
      // Assign this.seq in this.loadSeq()
      this.loadSeq();
    }
  }

  initComp() {
    // OlabUtils.infoLog("OlabComp.initComp() ...");
    this.comp = null;
    this.display_name = null;
    this.seq = null;
  }

  set(cItem) {
    this.comp = cItem.comp;
    this.display_name = cItem.display_name;
    this.seq = cItem.seq;
  }

  getDisplayName() {
    let dName = null;
    if (this.comp.name) {
      dName = this.comp.name;
    } else if (this.comp.old_locus_tag) {
      dName = this.comp.old_locus_tag;
    } else if (this.comp.locus_tag) {
      dName = this.comp.locus_tag;
    } else {
      dName = this.comp.olab_id;
    }
    return dName;
  }

  getSeqLength() {
    let len = 0;
    if (this.comp) {
      if (this.comp.olab_type == "strain") {
        if (this.seq && this.seq.gene_stats) {
          len = this.seq.gene_stats.len;
        }
      } else if (this.comp.olab_type == "library_sequence") {
        if (this.seq && this.seq.seq) {
          len = this.seq.seq.length;
        }
      } else if (this.comp.olab_type == "package") {
        len = 0;
      } else {
        OlabUtils.infoLog(
          "getSeqLength: Warning - comp's type unknown. Return 0 length"
        );
      }
    } else {
      OlabUtils.infoLog(
        "getSeqLength: Warning - comp is null. Return 0 length"
      );
    }
    return len;
  }

  static restoreSeqGene(seq) {
    if (seq && seq.comps) {
      const comps = seq.comps;
      for (let i = 0; i < comps.length; i++) {
        OlabUtils.infoLog("comps[" + i + "].olab_id = " + comps[i].olab_id);
        const comp = comps[i];
        if (comp.olab_id && comp.olab_type == "strain") {
          if (comp.seqGene) {
            comp.seq = comp.seqGene.sequence.seq;
          }
        }
      }
    }
  }

  static loadSeqGene(seq) {
    if (seq && seq.comps) {
      const comps = seq.comps;
      for (let i = 0; i < comps.length; i++) {
        OlabUtils.infoLog("comps[" + i + "].olab_id = " + comps[i].olab_id);
        const comp = comps[i];
        if (comp.olab_id && comp.olab_type == "strain") {
          db.collectionGroup("olab_genes")
            .withConverter(OlabGene.getOlabGeneConverter())
            .limit(2)
            .where("olab_id", "==", comp.olab_id)
            .get()
            .then(snapshot => {
              const snapArr = [];
              snapshot.forEach(doc => {
                // OlabUtils.infoLog("** " + doc.id + " => " + doc.data());
                snapArr.push(doc.data());
              });
              // OlabUtils.infoLog("snapArr len = " + snapArr.length);
              if (snapArr.length > 0) {
                comp.seqGene = snapArr[0];
              } else {
                OlabUtils.infoLog(
                  "Error!!! Gene not found: olab_id = " + comp.olab_id
                );
              }
            });
        }
      }
    }
  }

  loadSeq() {
    // OlabUtils.infoLog("loadSeq: olab_id = " + this.comp.olab_id);

    if (this.comp.olab_id) {
      if (this.comp.olab_type == "strain") {
        db.collectionGroup("olab_genes")
          .withConverter(OlabGene.getOlabGeneConverter())
          .limit(2)
          .where("olab_id", "==", this.comp.olab_id)
          .get()
          .then(snapshot => {
            const snapArr = [];
            snapshot.forEach(doc => {
              // OlabUtils.infoLog("** " + doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            // OlabUtils.infoLog("snapArr len = " + snapArr.length);
            if (snapArr.length > 0) {
              this.seq = snapArr[0];
            } else {
              OlabUtils.infoLog(
                "Error!!! Gene not found: olab_id = " + this.comp.olab_id
              );
            }
          });
      } else if (this.comp.olab_type == "library_sequence") {
        db.collectionGroup("olab_items")
          .withConverter(OlabItem.getOlabItemConverter())
          .limit(2)
          .where("olab_id", "==", this.comp.olab_id)
          .where("olab_type", "==", "library_sequence")
          .get()
          .then(snapshot => {
            const snapArr = [];
            snapshot.forEach(doc => {
              // OlabUtils.infoLog("** " + doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            // OlabUtils.infoLog("snapArr len = " + snapArr.length);
            if (snapArr.length > 0) {
              this.seq = snapArr[0];
            } else {
              OlabUtils.infoLog(
                "Error!!! Library Sequence not found: olab_id = " +
                  this.comp.olab_id
              );
            }
          });
      } else if (this.comp.olab_type == "package") {
        db.collectionGroup("olab_items")
          .withConverter(OlabItem.getOlabItemConverter())
          .limit(2)
          .where("olab_id", "==", this.comp.olab_id)
          .where("olab_type", "==", "package")
          .get()
          .then(snapshot => {
            const snapArr = [];
            snapshot.forEach(doc => {
              // OlabUtils.infoLog("** " + doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            // OlabUtils.infoLog("snapArr len = " + snapArr.length);
            if (snapArr.length > 0) {
              this.seq = snapArr[0];
              this.seq.seq = this.seq.library_id + " Package";
              // load comp's seqGenes if it is genome package
              if (this.seq.package_seq_type == "genome") {
                OlabUtils.infoLog(
                  this.seq.package_seq_type + " - loading seqGenes ..."
                );
                OlabComp.loadSeqGene(this.seq);
              }
            } else {
              OlabUtils.infoLog(
                "Error!!! Package not found: olab_id = " + this.comp.olab_id
              );
            }
          });
      } else {
        OlabUtils.infoLog(
          "Error!!! Unknown olab_type = " + this.comp.olab_type
        );
      }
    }
  }

  static computeAvailBoxType(currentBoxType, cartItems) {
    // OlabUtils.infoLog("computeAvailBoxType ...");
    // Reset flags
    OlabComp.availBoxType.gene = false;
    OlabComp.availBoxType.promoter = false;
    OlabComp.availBoxType.rbs = false;
    OlabComp.availBoxType.pgst = false;
    OlabComp.availBoxType.terminator = false;
    OlabComp.availBoxType.us_ds = false;

    // Take current box type into account
    switch (currentBoxType) {
      case "up_stream":
      case "down_stream":
        OlabComp.availBoxType.us_ds = true;
        break;
      case "gene":
        OlabComp.availBoxType.gene = true;
        break;
      case "promoter":
        OlabComp.availBoxType.promoter = true;
        break;
      case "rbs":
        OlabComp.availBoxType.rbs = true;
        break;
      case "pgst":
        OlabComp.availBoxType.pgst = true;
        break;
      case "terminator":
        OlabComp.availBoxType.terminator = true;
        break;
    }

    // OlabUtils.infoLog(
    //   "computeAvailBoxType : cartItems.length = " + cartItems.length
    // );
    for (let i = 0; i < cartItems.length; i++) {
      const comp = cartItems[i].comp;
      if (comp.available_count > 0) {
        switch (comp.use_seq_as) {
          case "arm":
            // arm sequence is to be used as US or DS
            OlabComp.availBoxType.us_ds = true;
            break;
          case "gene":
            OlabComp.availBoxType.gene = true;
            break;
          case "promoter":
            OlabComp.availBoxType.promoter = true;
            break;
          case "rbs":
            OlabComp.availBoxType.rbs = true;
            break;
          case "pgst":
            OlabComp.availBoxType.pgst = true;
            break;
          case "terminator":
            OlabComp.availBoxType.terminator = true;
            break;
        }
        if (comp.olab_type == "strain") {
          OlabComp.availBoxType.us_ds = true;
        }
      }
    }
  }

  static evalToAdd(ci, boxType, ciArr) {
    switch (boxType) {
      case "down_stream":
      case "up_stream":
        if (ci.comp.olab_type == "strain" || ci.comp.use_seq_as == "arm") {
          ciArr.push(ci);
        }
        break;
      case "gene":
        if (ci.comp.use_seq_as == "gene") {
          ciArr.push(ci);
        }
        break;
      case "promoter":
        if (ci.comp.use_seq_as == "promoter") {
          ciArr.push(ci);
        }
        break;
      case "rbs":
        if (ci.comp.use_seq_as == "rbs") {
          ciArr.push(ci);
        }
        break;
      case "pgst":
        if (ci.comp.use_seq_as == "pgst") {
          ciArr.push(ci);
        }
        break;
      case "terminator":
        if (ci.comp.use_seq_as == "terminator") {
          ciArr.push(ci);
        }
        break;
    }
  }

  static filterCartItems(currentItem, boxType, cartItems) {
    let ciArr = null;
    if (boxType != "") {
      ciArr = [];

      // Add currentItem into filter for selection
      if (currentItem) {
        OlabComp.evalToAdd(currentItem, boxType, ciArr);
      }

      for (let i = 0; i < cartItems.length; i++) {
        const ci = cartItems[i];
        if (ci.comp.available_count > 0) {
          OlabComp.evalToAdd(ci, boxType, ciArr);
        }
      }
    }
    return ciArr;
  }

  static infoLog(cItem) {
    OlabUtils.infoLog(" - comp.olab_id = " + cItem.comp.olab_id);
    OlabUtils.infoLog(" - comp.olab_type = " + cItem.comp.olab_type);
    OlabUtils.infoLog(" - comp.name = " + cItem.comp.name);
    OlabUtils.infoLog(" - comp.locus_tag = " + cItem.comp.locus_tag);
    OlabUtils.infoLog(" - comp.old_locus_tag = " + cItem.comp.old_locus_tag);
    OlabUtils.infoLog(" - display_name = " + cItem.display_name);
    OlabUtils.infoLog(" - seq = " + cItem.seq);
    OlabUtils.infoLog(" - comp.qty = " + cItem.comp.qty);
    OlabUtils.infoLog(" - comp.use_seq_as = " + cItem.comp.use_seq_as);
    OlabUtils.infoLog(" - comp.used_count = " + cItem.comp.used_count);
    OlabUtils.infoLog(
      " - comp.available_count = " + cItem.comp.available_count
    );
  }
}

export { OlabComp };
